__turbopack_context__.v({
  "--requires-scrolling": "add-metadata-step-module-scss-module__3KrlFG__--requires-scrolling",
  "__container": "add-metadata-step-module-scss-module__3KrlFG____container",
  "add-metadata-step": "add-metadata-step-module-scss-module__3KrlFG__add-metadata-step",
});
